module.exports = __webpack_public_path__ + "img/180.e776e633.jpg";